import aimeImage from './images/aime-b.png'
import amyImage from './images/amy-l.png'
import carolynImage from './images/carolyn-c.png'
import dinoImage from './images/dino-m.png'
import jackyImage from './images/jacky-l.png'
import johnImage from './images/john-s.png'
import jonathanImage from './images/jonathan-c.png'
import klausImage from './images/klaus-r.png'
import monicaImage from './images/monica-g.png'
import robImage from './images/rob-p.png'

const allLandlordTestimonials = [
  {
    avatar: klausImage,
    name: 'Klaus R.',
    company: 'Century 21 In Town Realty',
    review: `We have been using Liv.rent for a few months now as our exclusive screening tool for tenants. As a property manager, I like how easy it is for tenants to apply for a rental, and for us to review all the pertinent information in one place. The customer support team is also outstanding, and have been able to address any issues or questions very quickly.`,
    reviewCondensed: (
      <span>
        As a property manager,{' '}
        <strong>
          I like how easy it is for tenants to apply for a rental,
        </strong>{' '}
        and for us to review all the pertinent information in one place.
      </span>
    )
  },
  {
    avatar: robImage,
    name: 'Rob P.',
    company: 'Verified Landlord',
    review: `I recently found out about this platform for renters and Landlords. As a landlord, I gave it a try seeing it on fb. I must say, I'm quite impressed with all the bases it covers.  Could use more traffic to the posting, but bottom line is it's seamless, concise, covers so much, such as all the pertinent info to do with a lease, like being able to add amendments and be able to just send it electronically to your new tenant! WOW i said, save me time!!! Not to mention, they will soon be adding PAD for renters to pay.  So thorough with all the credit checks, financial background checks, credit score and all free if you only post less than ? 3 properties. I would have given 5 stars but I will leave room for more to come. Oh and Paula was soo helpful! Liv.rent where have you been all my life!!:) I'm sure I will now see Landlording in a different way going forward, and the app is very user friendly!`,
    reviewCondensed: (
      <span>
        It&apos;s seamless, concise, covers so much, such as all the pertinent
        info to do with a lease, like{' '}
        <strong>
          being able to add amendments and be able to just send it
          electronically to your new tenant!
        </strong>{' '}
        I&apos;m sure I will now see Landlording in a different way going
        forward, and the app is very user friendly!
      </span>
    )
  },
  {
    avatar: johnImage,
    name: 'John S.',
    company: 'Verified Landlord',
    review: `This is the first time I used liv.rent.  My experience has been very positive.   liv.rent has helped me with matching the prospect tenants meeting my requirements.  The whole process from advertisement to signing a contract is fully integrated and easy to use.  I also took advantage of the feature listing offer.  It was reasonably priced and of good value. With this offer, my ad was replicated in other Buy/Sell platforms. Paula was very helpful with getting the right information to these platforms.`,
    reviewCondensed: (
      <span>
        liv.rent has helped me with{' '}
        <strong>matching the prospect tenants meeting my requirements.</strong>{' '}
        The whole process from advertisement to signing a contract is fully
        integrated and easy to use.
      </span>
    )
  },
  {
    avatar: amyImage,
    name: 'Amy L.',
    company: 'Verified Landlord',
    review: `liv.rent is such an amazing all-in-one platform. It helps establish trust between renters and landlords through the unique dual ID verification process. As a landlord, I could reach lots of verified renters upon my ID was verified. Meanwhile, I received timely assistance from the liv.rent team. They are so enthusiastic and supportive. Indeed, a wonderful experience!!!`,
    reviewCondensed: (
      <span>
        liv.rent is such an amazing all-in-one platform.{' '}
        <strong>It helps establish trust between renters and landlords</strong>{' '}
        through the unique dual ID verification process. As a landlord, I could
        reach lots of verified renters upon my ID was verified.
      </span>
    )
  },
  {
    avatar: jonathanImage,
    name: 'Jonathan C.',
    company: 'Gather Co-Living',
    companyLink: '/company/gathercoliving',
    review: `We've been using liv.rent for our 60+ rooms and have been blown away by Paula's support! The selling point for us was the syndication of listings to facebook marketplace AND facebook groups. Also, they have taken alot of feedback from us for new features, something that's rare for property management software. They've been such a delight to work with! :)`,
    reviewCondensed: (
      <span>
        <strong>
          The selling point for us was the syndication of listings to facebook
          marketplace AND facebook groups.
        </strong>{' '}
        Also, they have taken alot of feedback from us for new features,
        something that&apos;s rare for property management software.
      </span>
    )
  },
  {
    avatar: aimeImage,
    name: 'Aime B.',
    company: 'Prompton Real Estate Services',
    companyLink: '/company/prompton',
    review: `The liv.rent team is incredibly responsive, innovative, professional and attentive. We use the app for our property listings and find amazing tenants that are thoroughly vetted through the app!! I would give 10 stars if I could!!`,
    reviewCondensed: (
      <span>
        The liv.rent team is incredibly responsive, innovative, professional and
        attentive. We use the app for our property listings and{' '}
        <strong>
          find amazing tenants that are thoroughly vetted through the app!
        </strong>
      </span>
    )
  },
  {
    avatar: jackyImage,
    name: 'Jacky L.',
    company: 'Verified Landlord',
    review: `Very easy to use - I found my tenant outside the app but I still use this app to construct and sign the contract. They make it easy to piece together the contract that you want.`,
    reviewCondensed: `Very easy to use - I found my tenant outside the app but I still use this app to construct and sign the contract. They make it easy to piece together the contract that you want.`
  },
  {
    avatar: dinoImage,
    name: 'Dino M.',
    company: 'Concert Properties',
    review: `liv.rent has been just [an] amazing place for advertising. Also, the clients we get from liv.rent are just amazing! Thank you liv.rent!`,
    reviewCondensed: `liv.rent has been just [an] amazing place for advertising.`
  },
  {
    avatar: monicaImage,
    name: 'Monica G.',
    company: 'Verified Landlord',
    review: `Service and support is great. Landlords and tenants are verified. I needed to finish my listing and Paula B was amazing, replied very fast to my questions, gave me the support, attention and guidance to get things done.`,
    reviewCondensed: `Service and support is great. Landlords and tenants are verified.`
  },
  {
    avatar: carolynImage,
    name: 'Carolyn C.',
    company: 'Verified Landlord',
    review: `Awesome customer services. It's a great tool to find quality tenants and properties for rent.`,
    reviewCondensed: `It's a great tool to find quality tenants and properties for rent.`
  },
  {
    avatar: carolynImage,
    name: 'Vania',
    company: 'Verified Landlord',
    review: `I’m happy to say I rented my place out, and it took 10 days from the beginning to end, just like last year. Yay! I hope you have a wonderful weekend, I really appreciate your patience with me!`,
    reviewCondensed: (
      <span>
        <strong>
          I’m happy to say I rented my place out, and it took 10 days from the
          beginning to end, just like last year.
        </strong>{' '}
        Yay! I hope you have a wonderful weekend, I really appreciate your
        patience with me!
      </span>
    )
  },
  {
    avatar: robImage,
    name: 'Frank J.',
    company: 'Refinity Homes',
    review: `Amazing experience. Been working with liv.rent for 1 year now and it has been such a pleasure!`,
    reviewCondensed: (
      <span>
        <strong>Amazing experience.</strong> Been working with liv.rent for 1
        year now and it has been such a pleasure!
      </span>
    )
  }
]

const landlordsPageTestimonials = [
  {
    avatar: klausImage,
    name: 'Klaus R.',
    company: 'Century 21 In Town Realty',
    review: `We have been using Liv.rent for a few months now as our exclusive screening tool for tenants. As a property manager, I like how easy it is for tenants to apply for a rental, and for us to review all the pertinent information in one place. The customer support team is also outstanding, and have been able to address any issues or questions very quickly.`,
    reviewCondensed: (
      <span>
        As a property manager,{' '}
        <strong>
          I like how easy it is for tenants to apply for a rental,
        </strong>{' '}
        and for us to review all the pertinent information in one place.
      </span>
    )
  },
  {
    avatar: johnImage,
    name: 'John S.',
    company: 'Verified Landlord',
    review: `This is the first time I used liv.rent.  My experience has been very positive.   liv.rent has helped me with matching the prospect tenants meeting my requirements.  The whole process from advertisement to signing a contract is fully integrated and easy to use.  I also took advantage of the feature listing offer.  It was reasonably priced and of good value. With this offer, my ad was replicated in other Buy/Sell platforms. Paula was very helpful with getting the right information to these platforms.`,
    reviewCondensed: (
      <span>
        liv.rent has helped me with{' '}
        <strong>matching the prospect tenants meeting my requirements.</strong>{' '}
        The whole process from advertisement to signing a contract is fully
        integrated and easy to use.
      </span>
    )
  },
  {
    avatar: jonathanImage,
    name: 'Jonathan C.',
    company: 'Gather Co-Living',
    companyLink: '/company/gathercoliving',
    review: `We've been using liv.rent for our 60+ rooms and have been blown away by Paula's support! The selling point for us was the syndication of listings to Facebook Marketplace AND Facebook Groups. Also, they have taken a lot of feedback from us for new features, something that's rare for property management software. They've been such a delight to work with! :)`,
    reviewCondensed: (
      <span>
        <strong>
          The selling point for us was the syndication of listings to facebook
          marketplace AND facebook groups.
        </strong>{' '}
        Also, they have taken alot of feedback from us for new features,
        something that&apos;s rare for property management software.
      </span>
    )
  },
  {
    avatar: carolynImage,
    name: 'Vania',
    company: 'Verified Landlord',
    review: `I’m happy to say I rented my place out, and it took 10 days from the beginning to end, just like last year. Yay! I hope you have a wonderful weekend, I really appreciate your patience with me!`,
    reviewCondensed: (
      <span>
        <strong>
          I’m happy to say I rented my place out, and it took 10 days from the
          beginning to end, just like last year.
        </strong>{' '}
        Yay! I hope you have a wonderful weekend, I really appreciate your
        patience with me!
      </span>
    )
  },
  {
    avatar: robImage,
    name: 'Frank J.',
    company: 'Refinity Homes',
    review: `Amazing experience. Been working with liv.rent for 1 year now and it has been such a pleasure!`,
    reviewCondensed: (
      <span>
        <strong>Amazing experience.</strong> Been working with liv.rent for 1
        year now and it has been such a pleasure!
      </span>
    )
  },
  {
    avatar: amyImage,
    name: 'Amy L.',
    company: 'Verified Landlord',
    review: `liv.rent is such an amazing all-in-one platform. It helps establish trust between renters and landlords through the unique dual ID verification process. As a landlord, I could reach lots of verified renters upon my ID was verified. Meanwhile, I received timely assistance from the liv.rent team. They are so enthusiastic and supportive. Indeed, a wonderful experience!!!`,
    reviewCondensed: (
      <span>
        liv.rent is such an amazing all-in-one platform.{' '}
        <strong>It helps establish trust between renters and landlords</strong>{' '}
        through the unique dual ID verification process. As a landlord, I could
        reach lots of verified renters upon my ID was verified.
      </span>
    )
  },
  {
    avatar: aimeImage,
    name: 'Aime B.',
    company: 'Prompton Real Estate Services',
    companyLink: '/company/prompton',
    review: `The liv.rent team is incredibly responsive, innovative, professional, and attentive. We use the app for our property listings and find amazing tenants who are thoroughly vetted through the app!! I would give 10 stars if I could!!`,
    reviewCondensed: (
      <span>
        The liv.rent team is incredibly responsive, innovative, professional and
        attentive. We use the app for our property listings and{' '}
        <strong>
          find amazing tenants that are thoroughly vetted through the app!
        </strong>
      </span>
    )
  },
  {
    avatar: robImage,
    name: 'Rob P.',
    company: 'Verified Landlord',
    review: `I recently found out about this platform for renters and Landlords. As a landlord, I gave it a try seeing it on fb. I must say, I'm quite impressed with all the bases it covers.  Could use more traffic to the posting, but bottom line is it's seamless, concise, covers so much, such as all the pertinent info to do with a lease, like being able to add amendments and be able to just send it electronically to your new tenant! WOW i said, save me time!!! Not to mention, they will soon be adding PAD for renters to pay.  So thorough with all the credit checks, financial background checks, credit score and all free if you only post less than ? 3 properties. I would have given 5 stars but I will leave room for more to come. Oh and Paula was soo helpful! Liv.rent where have you been all my life!!:) I'm sure I will now see Landlording in a different way going forward, and the app is very user friendly!`,
    reviewCondensed: (
      <span>
        It&apos;s seamless, concise, covers so much, such as all the pertinent
        info to do with a lease, like{' '}
        <strong>
          being able to add amendments and be able to just send it
          electronically to your new tenant!
        </strong>{' '}
        I&apos;m sure I will now see Landlording in a different way going
        forward, and the app is very user friendly!
      </span>
    )
  },
  {
    avatar: dinoImage,
    name: 'Dino M.',
    company: 'Concert Properties',
    review: `liv.rent has been just [an] amazing place for advertising. Also, the clients we get from liv.rent are just amazing! Thank you liv.rent!`,
    reviewCondensed: (
      <span>
        liv.rent has been just [an]{' '}
        <strong>amazing place for advertising.</strong>
      </span>
    )
  }
]

const useLandlordTestimonials = () => {
  return allLandlordTestimonials
}

export const useLandlordsPageLandlordTestimonials = () => {
  return landlordsPageTestimonials
}

export default useLandlordTestimonials
